"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpCommand = void 0;
class SignUpCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { customer } = this.input;
        const { cdp: cdpTracking } = config;
        const hashCustomerId = cdpTracking?.helper.md5(customer?.id ?? '');
        cdpTracking?.web_event.track('user', 'sign_up', {
            ...(customer && {
                dims: {
                    customers: {
                        customer_id: customer?.id ? hashCustomerId : 'no-customer-id',
                        name: customer?.name ?? 'no-customer-name',
                        email: customer?.email?.toLowerCase() ?? 'no-customer-email',
                        phone: customer?.phone ?? 'no-customer-phone',
                        cdp_source: 'Production',
                    },
                }
            }),
            extra: {},
        });
        return Promise.resolve();
    }
}
exports.SignUpCommand = SignUpCommand;
